import { AdyenPaymentMethodType, TransactionSplit } from "../Transaction";
import { PartnerWhiteLabelMetadata } from "../ClientPortalMetadata";
import { Currency } from "../Finance";

export interface GrowQuoteSessionView {
  session_id: string;
  quote_title: string;
  quote_amount: Money;
  surcharge_amount: Money;
  total_amount: Money;
  quote_url: string;
  allowed_payment_methods: AdyenPaymentMethodType[];
  partner_display_details: PartnerWhiteLabelMetadata;
}

export enum AdyenMandatedBy {
  Client = "client",
  Self = "self"
}

export interface AdyenSessionView {
  session_id: string;
  session_data: string;
}

export interface AdyenTransactionDataView {
  reference: string;
  mandated_by: AdyenMandatedBy;
  mandated_by_user_id?: number;
  expires_at: Date;
  original_amount: Money;
  total_amount: Money;
  surcharges_fee_amount: Money;
  splits?: TransactionSplit;
}

export interface PaymentsAdyenSessionDataView {
  session: AdyenSessionView;
  transaction_data: AdyenTransactionDataView;
}

export interface Money {
  value: number;
  currency: Currency;
}

export interface InvoiceTransactionData {
  reference: string;
  mandated_by: AdyenMandatedBy;
  mandated_by_user_id?: number;
  expires_at: Date;
  splits: TransactionSplit;
  total_amount: Money;
  surcharges_fee_amount: Money;
  original_amount: Money;
  surcharges_fee_description: string;
  surcharges_applied: boolean;
  invoice_pdf_url: string;
  branding_company_name: string;
}

export interface InvoicePaymentsAdyenSessionData {
  session: AdyenSessionView;
  transaction_data: InvoiceTransactionData;
}

export interface CreateAdyenSessionRequest {
  method: AdyenPaymentMethodType;
  mandated_by: AdyenMandatedBy;
  customer_id: number;
  mandated_by_user_id?: number;
}

export type AdyenEnvironment = "test" | "live" | "live-us" | "live-au" | "live-apse" | "live-in";
